module.exports = __webpack_public_path__ + "static/media/power-hp3.7b57295e.png";